// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  text-decoration: none;
  display: block;
}
.card:hover, .card:active, .card:focus {
  text-decoration: none;
}
.card:hover .card__title, .card:active .card__title, .card:focus .card__title {
  text-decoration: underline;
}
.card--without-image {
  border-top: 1px solid rgb(var(--colour-neutral-3, 223, 223, 223));
}
.card--large {
  font-size: 1rem;
  line-height: 1.625;
}
.card--large .card__title {
  font-size: 1.5rem;
  line-height: 1.45;
}
.card__info {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  padding-inline-start: 0;
}
.card__image, .card__info {
  box-sizing: border-box;
}
.card__title {
  margin-top: 0.5rem;
  font-size: 1.125rem;
  line-height: 1.444;
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
}
.card__body {
  margin-top: 1rem;
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
}
.card__icon {
  margin-top: 1rem;
  margin-inline-start: -0.1875rem;
  color: rgb(var(--colour-static-black, 17, 17, 17));
}
[dir=rtl] .card__icon {
  transform: scaleX(-1);
}
.card__btn {
  margin-top: 1.5rem;
}
.card__cta {
  display: inline-block;
}
.card__cta .card__btn {
  pointer-events: none;
}
.card__cta--with-button .card__btn {
  pointer-events: initial;
}
.card__label {
  font-size: 0.75rem;
  line-height: 1.5;
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
}
.card--emphasised {
  border-top: 0;
}
.card--emphasised .card__info {
  padding-inline-start: 1.5rem;
}
.card--emphasised .card__btn {
  margin-top: 3rem;
}
.card--emphasised .card__cta {
  margin-top: auto;
}
.card--emphasised .card__cta--with-button {
  margin-top: 0;
}
.card--emphasised .card__cta--with-button .card__btn {
  margin-top: 1.5rem;
}
.card--emphasised .card__icon {
  margin: 0;
}
.card--compact {
  display: flex;
  flex-direction: column;
}
.card--compact .card__image {
  flex-shrink: 0;
}
.card--compact .card__info {
  flex-grow: 1;
}

@media (min-width: 37.5em) {
  .card__info {
    padding-inline-end: 10rem;
  }
  .card--emphasised .card__info {
    padding: 2.5rem;
    padding-inline-end: 7.5rem;
  }
  .card--emphasised .card__btn {
    margin-top: 4rem;
  }
  .card--compact .card__info {
    padding: 1.5rem;
    padding-inline-start: 0;
  }
  .card--compact.card--emphasised .card__info {
    padding: 1.5rem;
  }
  .card--compact .card__text-wrapper {
    max-width: 30rem;
  }
  .card--compact .card__title {
    font-size: 1.125rem;
    line-height: 1.4444444444;
  }
  .card__title {
    font-size: 1.5rem;
    line-height: 1.45;
  }
  .card--large .card__title {
    font-size: 2.25rem;
    line-height: 1.333;
  }
}
@media (min-width: 75em) {
  .card {
    display: flex;
  }
  .card .card__image {
    flex-basis: 60%;
    max-width: 60%;
  }
  .card .card__image + .card__info {
    flex-basis: 40%;
    padding-inline-start: 3rem;
    padding-inline-end: 4rem;
    max-width: 40%;
  }
  .card:not(.card--emphasised) .card__image + .card__info {
    padding-top: 0;
    padding-bottom: 0;
  }
  .card--without-image:not(.card--emphasised), .card__text-wrapper {
    max-width: 37.5rem;
  }
  .card--trailing-image .card__image {
    order: 1;
  }
  .card--compact .card__image {
    flex-basis: auto;
    max-width: 100%;
    order: 0;
  }
  .card--compact .card__image + .card__info {
    flex-basis: auto;
    max-width: 100%;
    padding: 1.5rem;
    padding-inline-start: 0;
  }
  .card--compact .card__info {
    max-width: 30rem;
  }
  .card--compact .card__title {
    font-size: 1.125rem;
    line-height: 1.4444444444;
  }
  .card--emphasised .card__info {
    padding: 3rem;
    padding-inline-end: 4rem;
  }
  .card--emphasised .card__btn {
    margin-top: 3rem;
  }
  .card--compact.card--emphasised .card__info {
    padding: 1.5rem;
  }
  .card__btn {
    margin-top: 2rem;
  }
  .card__image-aspect-ratio {
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/@ingka/card/dist/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iEAAiE;AACnE;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;AACvD;AACA;EACE,gBAAgB;EAChB,qDAAqD;AACvD;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kDAAkD;AACpD;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;AACvD;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;IACf,0BAA0B;IAC1B,wBAAwB;IACxB,cAAc;EAChB;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".card {\n  text-decoration: none;\n  display: block;\n}\n.card:hover, .card:active, .card:focus {\n  text-decoration: none;\n}\n.card:hover .card__title, .card:active .card__title, .card:focus .card__title {\n  text-decoration: underline;\n}\n.card--without-image {\n  border-top: 1px solid rgb(var(--colour-neutral-3, 223, 223, 223));\n}\n.card--large {\n  font-size: 1rem;\n  line-height: 1.625;\n}\n.card--large .card__title {\n  font-size: 1.5rem;\n  line-height: 1.45;\n}\n.card__info {\n  display: flex;\n  flex-direction: column;\n  padding: 1.5rem;\n  padding-inline-start: 0;\n}\n.card__image, .card__info {\n  box-sizing: border-box;\n}\n.card__title {\n  margin-top: 0.5rem;\n  font-size: 1.125rem;\n  line-height: 1.444;\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n}\n.card__body {\n  margin-top: 1rem;\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n}\n.card__icon {\n  margin-top: 1rem;\n  margin-inline-start: -0.1875rem;\n  color: rgb(var(--colour-static-black, 17, 17, 17));\n}\n[dir=rtl] .card__icon {\n  transform: scaleX(-1);\n}\n.card__btn {\n  margin-top: 1.5rem;\n}\n.card__cta {\n  display: inline-block;\n}\n.card__cta .card__btn {\n  pointer-events: none;\n}\n.card__cta--with-button .card__btn {\n  pointer-events: initial;\n}\n.card__label {\n  font-size: 0.75rem;\n  line-height: 1.5;\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n}\n.card--emphasised {\n  border-top: 0;\n}\n.card--emphasised .card__info {\n  padding-inline-start: 1.5rem;\n}\n.card--emphasised .card__btn {\n  margin-top: 3rem;\n}\n.card--emphasised .card__cta {\n  margin-top: auto;\n}\n.card--emphasised .card__cta--with-button {\n  margin-top: 0;\n}\n.card--emphasised .card__cta--with-button .card__btn {\n  margin-top: 1.5rem;\n}\n.card--emphasised .card__icon {\n  margin: 0;\n}\n.card--compact {\n  display: flex;\n  flex-direction: column;\n}\n.card--compact .card__image {\n  flex-shrink: 0;\n}\n.card--compact .card__info {\n  flex-grow: 1;\n}\n\n@media (min-width: 37.5em) {\n  .card__info {\n    padding-inline-end: 10rem;\n  }\n  .card--emphasised .card__info {\n    padding: 2.5rem;\n    padding-inline-end: 7.5rem;\n  }\n  .card--emphasised .card__btn {\n    margin-top: 4rem;\n  }\n  .card--compact .card__info {\n    padding: 1.5rem;\n    padding-inline-start: 0;\n  }\n  .card--compact.card--emphasised .card__info {\n    padding: 1.5rem;\n  }\n  .card--compact .card__text-wrapper {\n    max-width: 30rem;\n  }\n  .card--compact .card__title {\n    font-size: 1.125rem;\n    line-height: 1.4444444444;\n  }\n  .card__title {\n    font-size: 1.5rem;\n    line-height: 1.45;\n  }\n  .card--large .card__title {\n    font-size: 2.25rem;\n    line-height: 1.333;\n  }\n}\n@media (min-width: 75em) {\n  .card {\n    display: flex;\n  }\n  .card .card__image {\n    flex-basis: 60%;\n    max-width: 60%;\n  }\n  .card .card__image + .card__info {\n    flex-basis: 40%;\n    padding-inline-start: 3rem;\n    padding-inline-end: 4rem;\n    max-width: 40%;\n  }\n  .card:not(.card--emphasised) .card__image + .card__info {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .card--without-image:not(.card--emphasised), .card__text-wrapper {\n    max-width: 37.5rem;\n  }\n  .card--trailing-image .card__image {\n    order: 1;\n  }\n  .card--compact .card__image {\n    flex-basis: auto;\n    max-width: 100%;\n    order: 0;\n  }\n  .card--compact .card__image + .card__info {\n    flex-basis: auto;\n    max-width: 100%;\n    padding: 1.5rem;\n    padding-inline-start: 0;\n  }\n  .card--compact .card__info {\n    max-width: 30rem;\n  }\n  .card--compact .card__title {\n    font-size: 1.125rem;\n    line-height: 1.4444444444;\n  }\n  .card--emphasised .card__info {\n    padding: 3rem;\n    padding-inline-end: 4rem;\n  }\n  .card--emphasised .card__btn {\n    margin-top: 3rem;\n  }\n  .card--compact.card--emphasised .card__info {\n    padding: 1.5rem;\n  }\n  .card__btn {\n    margin-top: 2rem;\n  }\n  .card__image-aspect-ratio {\n    height: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
